import reduce from 'lodash/reduce';

import { IBundlePackage } from '@r1-frontend/shared/types/tariff/bundle/IBundlePackage';
import { IInternetPackage } from '@r1-frontend/shared/types/tariff/mono/IInternetPackage';

import { ITariff } from '~/src/entities/formattedTariff';
import { ITariffs } from '~/src/entities/tariff-lines';
import { formattingBundleForCard, formattingTariffForCard } from '~/src/helpers/formatter';

interface ITariffsReduceByIsCottage{
    cottage: {
        bundles: ITariff[],
        mono: ITariff[],
        common: ITariff[],
    },
    notCottage: {
        bundles: ITariff[],
        mono: ITariff[],
        common: ITariff[],
    },
    hasBundles: boolean,
}


const reduceByIsCottage = (
    list: (IBundlePackage | IInternetPackage)[],
    formatter: (tariff: (IBundlePackage | IInternetPackage)) => ITariff,
) => {
    return reduce(list, (acc: { cottage: ITariff[], notCottage: ITariff[] }, item) => {
        const formattedTariff = formatter(item);
        formattedTariff.isCottage
            ? acc.cottage.push(formattedTariff)
            : acc.notCottage.push(formattedTariff);
        return acc;
    }, { cottage: [], notCottage: [] });
};

const NO_TARIFFS = {
    cottage: {
        bundles: [],
        mono: [],
        common: [],
    },
    notCottage: {
        bundles: [],
        mono: [],
        common: [],
    },
    hasBundles: false,
};

export const getTariffsReduceByIsCottage = (tariffs?: ITariffs): ITariffsReduceByIsCottage => {
    if (!tariffs) {
        return NO_TARIFFS;
    }

    const bundles = Object.values(tariffs.bundles);

    const {
        cottage: cottageBundles,
        notCottage: notCottageBundles,
    } = reduceByIsCottage(bundles, formattingBundleForCard);

    const {
        cottage: cottageMono,
        notCottage: notCottageMono,
    } = reduceByIsCottage(Object.values(tariffs.mono), formattingTariffForCard);

    return {
        cottage: {
            bundles: cottageBundles,
            mono: cottageMono,
            common: [...cottageBundles, ...cottageMono],
        },
        notCottage: {
            bundles: notCottageBundles,
            mono: notCottageMono,
            common: [...notCottageBundles, ...notCottageMono],
        },
        hasBundles: !!bundles.length,
    };
};
